import { Box, Link } from "@mui/material";
import { useTranslation } from "react-i18next";
import { VehicleTripLog } from "../../../hooks/Remote/Fleet/useRemoteFetchFleetLogbook";

export type LogbookAttachmentLinksProps = {
  log: VehicleTripLog;
};

/**
 * Renders attachment links for a log row (check-out and check-in photos),
 * same style as ConditionHistoryDialog attachments cell.
 */
export function LogbookAttachmentLinks({ log }: Readonly<LogbookAttachmentLinksProps>) {
  const { t } = useTranslation();
  const outUrls = log.checkOutPhotos ?? [];
  const inUrls = log.checkInPhotos ?? [];

  if (outUrls.length === 0 && inUrls.length === 0) return <>-</>;

  const links: React.ReactNode[] = [];

  outUrls.forEach((url, index) => {
    links.push(
      <Link
        key={`${log.id}-out-${index}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        {t("Image")} {index + 1} ({t("_fleetBookingEventCheckinAttachment")})
      </Link>
    );
  });

  inUrls.forEach((url, index) => {
    links.push(
      <Link
        key={`${log.id}-in-${index}`}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
      >
        {t("Image")} {index + 1} ({t("_fleetBookingEventCheckoutAttachment")})
      </Link>
    );
  });

  return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>{links}</Box>;
}
